import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AlternateConditionFeature,
} from "@dndModels";

import SelectConditionBox from "@dndComponents/select/SelectConditionBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  sff: AlternateConditionFeature;
  onChange: (sff: AlternateConditionFeature) => void; 
  disabled: boolean;
}

export default function AlternateConditionFeatureInput({ 
  sff,
  onChange,
  disabled
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 6
        }}>
        <SelectConditionBox 
          name="Original Condition" 
          value={sff.original_condition_id} 
          disabled={disabled}
          onChange={(id: string) => {
            const obj = sff;
            obj.original_condition_id = id;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectConditionBox 
          name="Alternate Condition" 
          value={sff.alternate_condition_id} 
          disabled={disabled}
          onChange={(id: string) => {
            const obj = sff;
            obj.alternate_condition_id = id;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Equivalent Level Multiplier" 
          value={`${sff.equivalent_level_multiplier}`} 
          disabled={disabled}
          type='number'
          onBlur={(changed: string) => {
            const obj = sff;
            obj.equivalent_level_multiplier = +changed;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        This number gets multiplied by the level of the new condition to determine 
        the equivalent level of the old condition.
        So if the multiplier is 0.5 and something happens at level 4 of the old condition, 
        then it happens at level 8 of the new condition.
      </Grid>
    </Grid>
  );
}
